// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

export const API_SERVICE_PREFIX = '/services';
// 前缀、微服务、地址
export const FILE_UPLOAD_URL = '/services/store/api/upload/';
export const CONFIG_VERSION = 1.3;
